import Model, { attr } from '@ember-data/model';

export default class WidgetTokenModel extends Model {
  @attr() token;
  @attr() expiresIn;
  @attr() data;
}
